"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : SORTABLE ITEM : STYLES --------------- ++++++++++ */


var _default = {
  sortableitem: {
    height: (0, _index.pxToEm)(48),
    width: '100%',
    //pxToEm(650),
    display: 'inline-flex',
    alignItems: 'center',
    margin: "".concat((0, _index.pxToEm)(5)),
    padding: "".concat((0, _index.pxToEm)(15)),
    backgroundColor: _index.theme.color.light.light.swatch,
    border: "".concat((0, _index.pxToEm)(1), " solid #ECF0F7"),
    borderRadius: '5px',
    boxShadow: "0px 1px 1px 0px #EDF1FA",
    '& .drag-icon': {
      opacity: '0.5'
    },
    '& .single-item-list': {
      marginLeft: "".concat((0, _index.pxToEm)(16))
    }
  }
};
exports.default = _default;